import React from 'react'
import styles from './iconStyles.module.scss'

export default function FaFolder() {
  return (
    <div className={styles.FaFolder} />
  )
}
